const SERVICE_MANAGEMENT_EXPERIENCE_TYPES = {
  EDIT_MISSION: '[serviceManagementExperience] editMission',
  ADD_PRISE_DE_SERVICE: '[serviceManagementExperience] addPriseDeService',
  REMOVE_PRISE_DE_SERVICE: '[serviceManagementExperience] removePriseDeService'
}

export default SERVICE_MANAGEMENT_EXPERIENCE_TYPES
